export const env = {
    primeBridgeUrl: process.env.REACT_APP_PRIME_BRIDGE_SERVICE_URI,
    portalUrl: process.env.REACT_APP_PORTAL_URI,
    ipAPIKey: process.env.REACT_APP_IP_API_KEY,
}
